module.exports = __webpack_public_path__ + "img/Word.47d84019.png";